import { Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ca-llm-configuration-toolbar',
    templateUrl: './llm-configuration-toolbar.component.html',
    styleUrl: './llm-configuration-toolbar.component.scss',
    standalone: false
})
export class LLMConfigurationToolbarComponent {
  @Output() toggleForm = new EventEmitter<void>();

  newLLMConfiguration(): void {
    this.toggleForm.emit();
  }
}
